import { Request } from 'api';
import { AxiosResponse } from 'axios';

export interface AuthResponse {
    first_name: string;
    last_name: string;
    user_name: string;
    email: string;
    phone: string;
    password: string;
    access_token: string;
    expires_at: string;
}
type CompletedRegistrationType = Promise<AxiosResponse<AuthResponse>>;

const userCompleteRegistrationWithSMS = (
    firstName: string,
    lastName: string,
    phone: string,
    code: string,
): CompletedRegistrationType => {
    return Request.post(`/authentication/sms/complete-registration`, {
        first_name: firstName,
        last_name: lastName,
        phone,
        code,
    });
};

export default userCompleteRegistrationWithSMS;
